import type { InitSessionConfigStep, QuestionConfigStep } from '@types';
import { extractStepAnswer } from './sessionEventHandlers';

/**
 * Risposta estratta da un evento sessionInfo
 */
export interface SessionAnswer {
  question: string;
  answer: string;
  stepId: number;
  timestamp: string;
}

/**
 * Estrae domanda e risposta da un evento sessionInfo
 * Prende i messaggi tipo ["step :0","answer:yyy"] e dalla config estrae la domanda
 */
export const extractQuestionAnswerFromSessionInfo = (
  messages: string[],
  config: InitSessionConfigStep[],
  timestamp?: string
): SessionAnswer | null => {
  if (!Array.isArray(messages) || messages.length === 0) {
    return null;
  }

  if (!Array.isArray(config) || config.length === 0) {
    return null;
  }

  // Estrae stepId e answer dai messaggi
  const stepAnswers = extractStepAnswer(messages);

  if (stepAnswers.length === 0) {
    return null;
  }

  // Prende la prima coppia step/answer valida
  const { stepId, answer } = stepAnswers[0];

  // Trova lo step nella config
  const step = config[stepId];

  if (!step) {
    return null;
  }

  // Verifica se è un QuestionConfigStep
  if (!('question' in step)) {
    return null;
  }

  const questionStep = step as QuestionConfigStep;

  // Estrae la question
  const question = questionStep.question || '';

  if (question === '') {
    return null;
  }

  // Usa il timestamp fornito o genera uno nuovo
  const answerTimestamp = timestamp || new Date().toISOString();

  return {
    question,
    answer,
    stepId,
    timestamp: answerTimestamp,
  };
};
